import React, { FC, useCallback, useState } from 'react';
import AccordionSection from './AccordionSection';
import { AccordionItem } from './types';

interface OwnProps {
  sections: AccordionItem[];
  showMarker?: boolean;
  alwaysOpen?: boolean;
}

const Accordion: FC<OwnProps> = ({ sections, showMarker, alwaysOpen }) => {
  const [openSections, changeOpenSection] = useState<Record<number, boolean>>({ 0: true });

  const onClickHandler = useCallback(
    (id: number) => () => {
      const currentSectionOpenState = openSections[id];
      changeOpenSection({
        ...openSections,
        [id]: !currentSectionOpenState,
      });
    },
    [openSections, changeOpenSection],
  );
  const isOpen = (index: number) => alwaysOpen || openSections[index];

  return (
    <>
      {sections.map((section, index) => {
        return (
          <AccordionSection
            key={index}
            isOpen={isOpen(index)}
            showMarker={!!showMarker}
            title={section.title}
            onClick={onClickHandler(index)}
          >
            {section.content}
          </AccordionSection>
        );
      })}
    </>
  );
};

export default Accordion;
